import { StateUtils } from '@spartacus/core';
import { OrderEntry } from '../../../../../core/model';
import { matchEntry } from '../../../../../shared';
import { CartEntryCuttingActionTypes } from '../actions/cart-entry-cutting.action';
import { CartEntryFullPalletNoteActionTypes } from '../actions/cart-entry-full-pallet-note.action';
import { CartEntryPalletFlagsActionTypes } from '../actions/cart-entry-pallet-flags.action';
import { CartEntryReamingActionTypes } from '../actions/cart-entry-reaming.action';
import { CartEntryReelCuttingActionTypes } from '../actions/cart-entry-reel-cutting.action';
import { CartEntryActionTypes } from '../actions/cart-entry.action';
import { CartActions } from '../actions/index';
import { reducer as cartEntryCuttingReducer } from './cart-entry-cutting.reducer';
import { reducer as cartEntryFullPalletNoteReducer } from './cart-entry-full-pallet-note.reducer';
import { reducer as cartEntryPalletFlagsReducer } from './cart-entry-pallet-flags.reducer';
import { reducer as cartEntryReamingReducer } from './cart-entry-reaming.reducer';
import { reducer as cartEntryReelCuttingReducer } from './cart-entry-reel-cutting.reducer';

const initialState: OrderEntry[] = [];

export function reducer(
  state = initialState,
  action:
    | CartActions.CartEntryActions
    | CartActions.CartEntryFullPalletNoteActions
    | CartActions.CartEntryCuttingActions
    | CartActions.CartEntryReelCuttingActions
    | CartActions.CartEntryReamingActions
    | CartActions.CartEntryPalletFlagsActions
    | StateUtils.LoaderAction
): OrderEntry[] {
  switch (action.type) {
    case CartEntryActionTypes.RemoveCartEntrySuccess: {
      const _action = <CartActions.RemoveCartEntrySuccess>action;
      return state.filter((entry) => !matchEntry(entry, _action.payload.entry));
    }
    case CartEntryActionTypes.RemoveCartEntriesSuccess: {
      const _action = <CartActions.RemoveCartEntriesSuccess>action;
      return state.filter((entry) => !_action.payload.entries.some((removedEntry) => matchEntry(entry, removedEntry)));
    }
    case CartEntryActionTypes.RemoveAllCartEntriesSuccess: {
      return [];
    }
    case CartEntryActionTypes.UpdateCartEntrySuccess: {
      const _action = <CartActions.UpdateCartEntrySuccess>action;
      const updatedEntry = _action.payload.cartModification?.entry;
      return state.map((entry) => (matchEntry(entry, updatedEntry) ? updatedEntry : entry));
    }
    case CartEntryFullPalletNoteActionTypes.AddCartEntryFullPalletNoteSuccess:
    case CartEntryFullPalletNoteActionTypes.RemoveCartEntryFullPalletNoteSuccess: {
      const _action = <CartActions.AddCartEntryFullPalletNoteSuccess | CartActions.RemoveCartEntryFullPalletNoteSuccess>action;
      return state.map((entry) =>
        matchEntry(entry, _action.payload.entry)
          ? {
              ...entry,
              fullPalletNote: cartEntryFullPalletNoteReducer(entry.fullPalletNote, _action),
            }
          : entry
      );
    }
    case CartEntryCuttingActionTypes.AddCartEntryCuttingSuccess:
    case CartEntryCuttingActionTypes.RemoveCartEntryCuttingSuccess: {
      const _action = <CartActions.AddCartEntryCuttingSuccess | CartActions.RemoveCartEntryCuttingSuccess>action;
      return state.map((entry) =>
        matchEntry(entry, _action.payload.entry)
          ? {
              ...entry,
              cutting: cartEntryCuttingReducer(entry.cutting, _action),
            }
          : entry
      );
    }
    case CartEntryReelCuttingActionTypes.AddCartEntryReelCuttingSuccess:
    case CartEntryReelCuttingActionTypes.RemoveCartEntryReelCuttingSuccess: {
      const _action = <CartActions.AddCartEntryReelCuttingSuccess | CartActions.RemoveCartEntryReelCuttingSuccess>action;
      return state.map((entry) =>
        matchEntry(entry, _action.payload.entry)
          ? {
              ...entry,
              reelCutting: cartEntryReelCuttingReducer(entry.reelCutting, _action),
            }
          : entry
      );
    }
    case CartEntryReamingActionTypes.AddCartEntryReamingSuccess:
    case CartEntryReamingActionTypes.RemoveCartEntryReamingSuccess: {
      const _action = <CartActions.AddCartEntryReamingSuccess | CartActions.RemoveCartEntryReamingSuccess>action;
      return state.map((entry) =>
        matchEntry(entry, _action.payload.entry)
          ? {
              ...entry,
              reaming: cartEntryReamingReducer(entry.reaming, _action),
            }
          : entry
      );
    }
    case CartEntryPalletFlagsActionTypes.UpdateCartEntryPalletFlagsSuccess: {
      const _action = <CartActions.UpdateCartEntryPalletFlagsSuccess>action;
      return state.map((entry) =>
        matchEntry(entry, _action.payload.entry)
          ? {
              ...entry,
              palletFlags: cartEntryPalletFlagsReducer(entry.palletFlags, _action),
            }
          : entry
      );
    }
  }
  return state;
}
